import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubscriptionProductCreateRequestDto } from "@/dto/SubscriptionDto";
import { Yn } from "@/constants/code";

/**
 * 구독 상품 생성 폼 Hook
 *
 * @returns
 *
 * @author Max <sud665@ymjlab.com>
 * @version 1.0
 * @since 2025-05-08
 */
export default function useCreateForm(
  onSubmit: (data: SubscriptionProductCreateRequestDto) => void
) {
  const methods = useForm<SubscriptionProductCreateRequestDto>({
    resolver: yupResolver(
      yup.object().shape({
        productNm: yup.string().required("상품명을 입력해주세요."),
        productType: yup.string().required("상품 유형을 선택해주세요."),
        productDtl: yup.string().required("상품 상세 설명을 입력해주세요."),
        firstYearAmt: yup
          .number()
          .required("연간 금액을 입력해주세요.")
          .min(0, "0 이상의 금액을 입력해주세요."),
        monthlyAmt: yup
          .number()
          .required("월간 금액을 입력해주세요.")
          .min(0, "0 이상의 금액을 입력해주세요."),
        currency: yup.string().required("통화를 선택해주세요."),
        prepaidPeriod: yup
          .number()
          .required("선납 기간을 입력해주세요.")
          .min(1, "1개월 이상을 입력해주세요.")
          .max(12, "12개월 이하를 입력해주세요."),
        activeYn: yup.mixed<Yn>().oneOf([Yn.Y, Yn.N]).default(Yn.Y),
      })
    ),
    defaultValues: {
      productType: "BASIC",
      currency: "USD",
      prepaidPeriod: 12,
      activeYn: Yn.Y,
    },
  });

  const handleSubmit = methods.handleSubmit((data) => {
    console.log("=== Form Data in useCreateForm ===");
    console.log("All form data:", data);
    onSubmit(data);
  });

  return {
    methods,
    handleSubmit,
  };
}
